import { render, staticRenderFns } from "./ClassCSAT.vue?vue&type=template&id=9641dc1e&"
import script from "./ClassCSAT.vue?vue&type=script&lang=ts&"
export * from "./ClassCSAT.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports